import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./AnnouncementDetail.css";

const AnnouncementDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { title, date, details } = location.state || {};

  if (!title || !details) {
    return <p>Announcement not found. Please go back and try again.</p>;
  }

  return (
    <div className="announcement-detail-container">
      <div className="announcement-box">
        <h2>{title}</h2>
        <p className="announcement-date">Date: {date}</p>
        <p className="announcement-details">Details: {details}</p>
        <button onClick={() => navigate(-1)} className="back-button">
          ←
        </button>
      </div>
    </div>
  );
};

export default AnnouncementDetail;
